import { z } from "zod";

import http from "@/services/http";

const classRegisterRequest = z.object({
  instanceId: z.string(),
  parentOrderId: z.string(),
});

export type ClassRegisterRequest = z.infer<typeof classRegisterRequest>;

export async function fetchUpcomingClasses(classID: number) {
  const { data } = await http().get(
    window.env.API_APOLLO_MIDDLEWARE + "/upcoming-user-classes/" + classID
  );
  return data;
}

export async function registerClasses(request: ClassRegisterRequest) {
  classRegisterRequest.parse(request);
  const { data } = await http().post(
    window.env.API_APOLLO_MIDDLEWARE + "/register-learner",
    request
  );
  return data;
}

export async function unRegisterClasses(instanceId: any) {
  const { data } = await http().get(
    window.env.API_APOLLO_MIDDLEWARE + "/unregister-user/" + instanceId
  );
  return data;
}

export async function getOrderId(request: any) {
  const { data } = await http().get(
    window.env.API_DIGITAL_ENTITLEMENT +
      "/user-entitlements?includeBundleInfo=true&content_bundle=" +
      request.content_bundle
  );
  return data;
}

export async function getAllEntitlements() {
  const { data } = await http().get(
    window.env.API_DIGITAL_ENTITLEMENT +
      "/user-entitlements?includeBundleInfo=true&activeEntitlements=false"
  );
  return data;
}

export async function getUpcomingClasses() {
  const { data } = await http().get(
    window.env.API_APOLLO_MIDDLEWARE + "/instances?days=30"
  );
  return data;
}

export const popularProduct = z.object({
  gui: z.number(),
  status: z.string(),
  product_name: z.string(),
  product_title: z.string(),
  product_type: z.string(),
  ga_date: z.string(),
});

const popularNewResponse = z.object({
  popular_catalogs: z.array(popularProduct),
  new_catalogs: z.array(popularProduct),
});

export type PopularTypes = z.infer<typeof popularProduct>;

export type PopularResponse = z.infer<typeof popularNewResponse>;

export async function getPopularNew() {
  const { data } = await http().get(
    `${window.env.API_APOLLO_MIDDLEWARE}/store/popular-new-catalogs`
  );
  return popularNewResponse.parse(data);
}
